import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export const CustomAccordion = styled(Accordion)(({ theme }) => ({
  position: "relative",
  width:"100%",
  backgroundColor: "transparent",
  padding: 0,
  margin: 0,
  borderColor: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "none",
  "&:before": {
    display: "none",
  },
}));

export const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: "transparent",
 
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.divider}`,
  "& .MuiAccordionSummary-content": {
    marginY: theme.spacing(1),
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: theme.palette.text.secondary,
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
}));

export const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: "transparent",

  color: theme.palette.text.secondary,
  borderTop: `1px solid ${theme.palette.divider}`,
  
}));

const AnimatedAccordion = ({ customfontsize,summaryText, detailsText ,...props}) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <CustomAccordion expanded={expanded} onChange={handleToggle} {...props}>
      <CustomAccordionSummary
        expandIcon={expanded ? <RemoveIcon   style={{fontSize: `${1.2*customfontsize}px` }}/> : <AddIcon style={{fontSize: `${1.2*customfontsize}px` }} />}
      >
        <Typography style={{fontSize: `${customfontsize}px` }}>{summaryText}</Typography>
      </CustomAccordionSummary>
      <CustomAccordionDetails>
        <Typography  style={{fontSize: `${customfontsize}px` }}>{detailsText}</Typography>
      </CustomAccordionDetails>
    </CustomAccordion>
  );
};

export default AnimatedAccordion;
